// easyui-window.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-window',
  template: `
    <div #host>
      <ng-content></ng-content>
    </div>
  `
})
export class EasyuiWindowComponent implements AfterViewInit {
  private host: any;
  @Input('options') options: any = {};
  @ViewChild('host') hostElement: ElementRef;

  constructor() {}

  ngAfterViewInit() {
    this.configura(this.options);
  }

  public open() {
    this.host.window('open');
  }

  public close() {
    this.host.window('close');
  }

  public center() {
    this.host.window('center');
  }

  public resize(width: any, height: any) {
    this.host.window('resize', {width, height});
  }

  public onClose(callback: Function) {
    this.host.window({onClose: callback});
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi privati

  private configura(options: any) {
    const localoptions  = {
      width: 300,
      height: 200,
      maximizable: false,
      minimizable: false,
      collapsible: false
    };
    this.host = $(this.hostElement.nativeElement);
    Object.assign(localoptions, options);
    this.host.window(localoptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-window.component.ts